export interface CommanderActionDef {
  name: string;
  description: string;
}

/**
 * Product Redemptions dashboard actions.
 * `action_id` keys are stable; `name` / `description` are what GA users read.
 */
export const REDEMPTION_ACTIONS = {
  dashboard_view: {
    name: "View Dashboard",
    description:
      "User opened Product Redemptions and loaded the summary for the current filters",
  },
  source_change: {
    name: "Change Source Tab",
    description:
      "User switched between Individual, Onelink, or All redemption sources",
  },
  filter_apply: {
    name: "Apply Filters",
    description:
      "User applied date, order, and/or customer filters and refreshed the dashboard",
  },
  filter_clear: {
    name: "Clear Filters",
    description:
      "User cleared date/order/customer filters (source tab was kept)",
  },
  dashboard_refresh: {
    name: "Refresh Dashboard",
    description:
      "User clicked Refresh to reload the summary with the already applied filters",
  },
  drawer_refresh: {
    name: "Refresh Card",
    description:
      "User clicked Refresh inside an open card to reload it with applied filters",
  },
  date_preset_select: {
    name: "Select Date Preset",
    description:
      "User picked a quick date chip (Last 7 / 30 / 90 days, or FY) before Apply",
  },
  date_range_change: {
    name: "Pick Custom Dates",
    description:
      "User changed the custom date range in draft filters (before Apply)",
  },
  journey_card_click: {
    name: "Open Journey Card",
    description:
      "User opened a Coupon Journey card (Created / Sent / Redeemed / Shipments Created / Pending / Expired)",
  },
  product_row_click: {
    name: "Open Product Card",
    description: "User opened a product row in Products Redeemed",
  },
  variant_matrix_open: {
    name: "Open Variant Matrix Card",
    description: "User opened the Product · variant · count matrix",
  },
  drawer_close: {
    name: "Close Card",
    description: "User closed the open redemption card drawer",
  },
  product_view_change: {
    name: "Change Product View",
    description:
      "User switched tabs inside an open product card (lines / pack / variant / city)",
  },
  matrix_groupby_change: {
    name: "Change Matrix Group By",
    description: "User switched grouping inside the open variant matrix",
  },
  table_sort: {
    name: "Sort Card Table",
    description: "User sorted a column inside an open redemption card",
  },
  table_page_change: {
    name: "Change Card Page",
    description: "User changed page inside an open redemption card table",
  },
  table_page_size_change: {
    name: "Change Card Rows Per Page",
    description: "User changed rows per page inside an open redemption card",
  },
  export_csv: {
    name: "Export Card CSV",
    description: "User exported CSV for the currently open redemption card",
  },
  search_panel_toggle: {
    name: "Toggle Search Panel",
    description: "User expanded or collapsed the Search filters panel",
  },
  formula_toggle: {
    name: "Toggle Formula Help",
    description:
      "User expanded or collapsed How this is calculated on an open card",
  },
} as const satisfies Record<string, CommanderActionDef>;

export type RedemptionActionId = keyof typeof REDEMPTION_ACTIONS;
